export const VALIDATOR_WAIT_MESSAGE = "Validator not available. Please wait...";

const VALIDATOR_UNAVAILABLE =
  /could not reach|marimo[- ]validator|marimo validator|v1\/run|validator is not configured|timed out waiting for a validator|failed to fetch|networkerror|econnrefused/i;

export function notebookRunnerUserMessage(error?: string, fallback = "Run failed."): string {
  const text = String(error || "").trim();
  if (!text) return fallback;
  if (VALIDATOR_UNAVAILABLE.test(text)) return VALIDATOR_WAIT_MESSAGE;
  return text;
}
